import styled from 'styled-components'

export const CalendarContainer = styled.div`
  height: 'auto';
  width: '100%';
  margin-top: '35px';
`
export const CalendarToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 40px 0;
`
export const CalendarToolbarDay = styled.p`
  margin: 0;
  margin-right: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.secondary};
`

export const CalendarToolbarDayNumber = styled.p`
  margin: 0;
  margin-right: 36px;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral};
`

export const CalendarTimeColumn = styled.div`
  margin-top: 56px;
`
